import React, { useState } from "react";
import { Button, Drawer, message } from "antd";
import { useNavigate } from "react-router-dom";
import Hotel1 from "../assets/images/hotels/hotel-1.jpg";
import Hotel2 from "../assets/images/hotels/hotel-2.webp";
import Hotel3 from "../assets/images/hotels/hotel-3.jpg";
import Hotel4 from "../assets/images/hotels/hotel-4.jpg";
import Hotel5 from "../assets/images/hotels/hotel-5.jpg";
import { Date } from "../components/formatter";
import { CheckOutlined } from "@ant-design/icons";

const Results = () => {
  const [visible, setVisible] = useState(false);
  const [item, setItem] = useState("");
  const navigate = useNavigate();

  const hotels = [
    {
      id: 1,
      name: "The Lalit Mumbai",
      image: Hotel1,
      address: "Andheri East | 1.3 km drive to International Airport",
      price: "₹ 20,636",
      amenities: ["Jacuzzi", "SpaSpa", "Swimming PoolSwimming Pool"],
      features: [
        "Free Cancellation till 24 hrs before check in",
        " Breakfast Included",
      ],
      rooms: [
        { roomType: "Premier Room Twin Bed", roomPrice: "₹ 20,636" },
        { roomType: "Room King Bed", roomPrice: "₹ 24,730" },
        { roomType: "Executive Club Twin Bed", roomPrice: "₹ 25,549" },
      ],
    },
    {
      id: 2,
      name: "Ginger Mumbai Airport",
      image: Hotel2,
      address: "Andheri East | 1.3 km drive to International Airport",
      price: "₹ 11,999",
      amenities: ["Jacuzzi", "SpaSpa", "Swimming PoolSwimming Pool"],
      features: [
        "Free Cancellation till 24 hrs before check in",
        " Breakfast Included",
      ],
      rooms: [
        { roomType: "Premier Room Twin Bed", roomPrice: "₹ 11,999" },
        { roomType: "Room King Bed", roomPrice: "₹ 12,730" },
        { roomType: "Executive Club Twin Bed", roomPrice: "₹ 14,549" },
      ],
    },
    {
      id: 3,
      name: "Lemon Tree Premier",
      image: Hotel3,
      address: "Andheri East | 1.3 km drive to International Airport",
      price: "₹ 14,999",
      amenities: ["Jacuzzi", "SpaSpa", "Swimming PoolSwimming Pool"],
      features: [
        "Free Cancellation till 24 hrs before check in",
        " Breakfast Included",
      ],
      rooms: [
        { roomType: "Premier Room Twin Bed", roomPrice: "₹ 14,999" },
        { roomType: "Room King Bed", roomPrice: "₹ 16,730" },
        { roomType: "Executive Club Twin Bed", roomPrice: "₹ 18,549" },
      ],
    },
    {
      id: 4,
      name: "Taj Santacruz, Mumbai",
      image: Hotel4,
      address: "Andheri East | 1.3 km drive to International Airport",
      price: "₹ 23,500",
      amenities: ["Jacuzzi", "SpaSpa", "Swimming PoolSwimming Pool"],
      features: [
        "Free Cancellation till 24 hrs before check in",
        " Breakfast Included",
      ],
      rooms: [
        { roomType: "Premier Room Twin Bed", roomPrice: "₹ 23,500" },
        { roomType: "Room King Bed", roomPrice: "₹ 24,730" },
        { roomType: "Executive Club Twin Bed", roomPrice: "₹ 25,549" },
      ],
    },
    {
      id: 5,
      name: "Trident Bandra Kurla",
      image: Hotel5,
      address: "Andheri East | 1.3 km drive to International Airport",
      price: "₹ 24,300",
      amenities: ["Jacuzzi", "SpaSpa", "Swimming PoolSwimming Pool"],
      features: [
        "Free Cancellation till 24 hrs before check in",
        " Breakfast Included",
      ],
      rooms: [
        { roomType: "Premier Room Twin Bed", roomPrice: "₹ 24,300" },
        { roomType: "Room King Bed", roomPrice: "₹ 26,730" },
        { roomType: "Executive Club Twin Bed", roomPrice: "₹ 28,549" },
      ],
    },
  ];

  const selectItem = (record) => {
    setItem(record);
    setVisible(true);
  };

  const handleRequest = (item, room) => {
    let reqData = JSON.parse(localStorage.getItem("reqData"));
    let search = JSON.parse(localStorage.getItem("search"));

    let newitem = {
      id: reqData.length + 1,
      requestDate: Date(),
      type: "Hotel",
      location: search?.location,
      name: item?.name,
      dates: Date(search?.dates[0]) + " - " + Date(search?.dates[1]),
      room: room?.roomType,
      price: room?.roomPrice,
      status: "New",
    };

    reqData.push(newitem);
    localStorage.setItem("reqData", JSON.stringify(reqData));
    message.success("Booking Request sent successfully.");
    setVisible(false);
    navigate("/dashboard");
  };

  const search = JSON.parse(localStorage.getItem("search"));

  return (
    <div className="mt-3">
      <div className="container">
        <div className="results">
          <div className="results-title mb-4">
            <h1>Showing 540 Properties in {search?.location}</h1>
            <h4>
              {Date(search?.dates[0])} to {Date(search?.dates[1])} -
              {search?.rooms}
            </h4>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="results-cont">
                {hotels.map((x) => (
                  <div className="result-item">
                    <div className="row">
                      <div className="col-lg-3">
                        <img src={x?.image} alt="" />
                      </div>
                      <div className="col-lg-7">
                        <div className="result-item-details">
                          <h2>{x?.name}</h2>
                          <div className="text-secondary">{x?.address}</div>
                          <div className="mt-3">
                            {x?.amenities.map((y) => (
                              <div className="result-item-amenity">{y}</div>
                            ))}
                          </div>
                          <div className="mt-3">
                            {x?.features.map((y) => (
                              <div className="mb-1">
                                <CheckOutlined className="me-2" />
                                {y}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="result-item-price">
                          <div>
                            <h3>{x?.price}</h3>
                            <div className="text-secondary mb-3">per night</div>
                            <Button
                              type="primary"
                              onClick={() => selectItem(x)}
                            >
                              Select Room
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Drawer
        title="Select Room"
        onClose={() => setVisible(false)}
        open={visible}
        size="large"
      >
        <div className="result-rooms">
          {item &&
            item?.rooms.map((x, key) => (
              <div className="mb-2 pb-2 border-bottom" key={key}>
                <div className="row">
                  <div className="col-lg-8">
                    <h5>{x?.roomType}</h5>
                  </div>
                  <div className="col-lg-2">
                    <h5>{x?.roomPrice}</h5>
                  </div>
                  <div className="col-lg-2">
                    <Button
                      type="primary"
                      onClick={() => handleRequest(item, x)}
                    >
                      Request
                    </Button>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </Drawer>
    </div>
  );
};

export default Results;
